import {globalsObject} from "@k/js/globalsObject"
export function getInsertionTarget() {
    return globalsObject.selObInsertionFinder.getInsertionPoint();
}

